import { format } from 'date-fns';
import { DATE_FORMAT_INTERNAL } from 'constants/v2/dates';

export const formatDate = date => format(date, DATE_FORMAT_INTERNAL);
